<template>
    <div>
        <p class="created-by">{{createdBy}}</p>
        <p class="subhead" v-if="category && createdTime">
            {{category}} • {{ createdTime ? $dateUtils.formatDateTime(createdTime) : "" }}
        </p>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
    name: 'CardHeader',
    props: {
        createdBy: String,
        category: String,
        createdTime: Date,
    }
})
</script>